export function secondaryNavTabTestId(canonicalName: string): string {
  return `secondary-nav-tab-${canonicalName.toLowerCase().replace(/\s+/g, "-")}`;
}
